import type React from "react";
import { faqItems } from "@/data/faqData";
import FAQItem from "./FAQItem";

const FAQ: React.FC = () => {
	return (
		<section className="py-16 bg-white">
			<div className="container mx-auto">
				<h2 className="text-3xl font-bold text-center mb-12">よくある質問</h2>
				<div className="space-y-6">
					{faqItems
						.filter((item) => item.isFeatured)
						.map((item) => (
							<FAQItem
								key={item.id}
								question={item.title}
								answer={item.content}
							/>
						))}
				</div>
			</div>
		</section>
	);
};

export default FAQ;
